import { loadJs } from './utilities'

const url = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js'

const EVENTS = {
	GPT_LOADED: 'mega.gpt.loaded'
}

export function load(callback:Function = ()=>{}) {
	loadJs(url, () => { dispatchEvent(new CustomEvent(EVENTS.GPT_LOADED)), callback() })
}